export const config = {
  eventGroup: 'jw1_zlp_pc_202603',
  name: '《剑网1》26年3月资料片专题',
  identify: 'jx',
  eventTags: ['jw1', 'zlp', 'pc']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 上报按钮名称：内功崛起；界面洞玄；开年新服；礼酬侠士；玩法焕新
     */
    clickHomepageButton: function(title) {
      report({
        eventName: 'click_homepage_button',
        eventDescription: '点击首页聚合页按钮',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    loadInnerPage: function() {
      report({
        eventName: 'load_inner_page',
        eventDescription: '内页加载',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickGoOfficial: function() {
      report({
        eventName: 'click_go_official',
        eventDescription: '点击进入官网'
      });
    },
    clickGoDownload: function() {
      report({
        eventName: 'click_go_download',
        eventDescription: '点击下载游戏'
      });
    },
    /**
     * @param {string} [title] - 上报导航栏按钮名称：内功崛起、界面洞玄、开年新服、礼酬侠士、玩法焕新
     */
    clickNavTitle: function(title) {
      report({
        eventName: 'click_nav_title',
        eventDescription: '点击内页导航栏',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报子内页标题：界面改造；修行指引；决战烽火；帮会宝箱；新服礼卡；每日宝箱
     */
    clickSubtab: function(title) {
      report({
        eventName: 'click_subtab',
        eventDescription: '点击切换子内页小标题',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报曝光的内页大标题：内功崛起刷怪增伤；界面洞玄引脉通络；礼酬侠士福满江湖；玩法焕新体验进阶；
     */
    exposeSection: function(title) {
      report({
        eventName: 'expose_section',
        eventDescription: '内页大标题曝光',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
